import React from 'react';
import PropTypes from 'prop-types';

const PotsPansNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1 9.388h22m-19.8 0 .554 5.852c.26 2.736.389 4.103 1.335 4.931.945.829 2.376.829 5.238.829h3.346c2.862 0 4.293 0 5.238-.829.946-.828 1.075-2.195 1.335-4.931l.554-5.852M3.2 7.278l5.5-1.426m0 0 6.6-1.71m-6.6 1.71.227-1.834c.039-.327.18-.636.403-.885.223-.25.52-.43.85-.516l2.167-.562c.33-.084.679-.072 1.002.037.322.108.604.307.807.57l1.144 1.48m0 0 5.5-1.426"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

PotsPansNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default PotsPansNot;
